import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';

import { getPlateSizeString, getPlateTypeAndSizeString, getPlateTypeString } from '@paragon/material-lists';

import { BundlePlatePartEntry } from '../../../../store/selectors/getBundleAssemblyPlatePartEntriesByBundleGuid';
import { PropertyTable, zebraStripingSx } from '../../subpanels/properties/PropertyTable';

interface BundleAssemblyPlatePartsProps {
  readonly bundlePlatePartEntries: readonly BundlePlatePartEntry[];
  readonly showBundleIdHeader: boolean;
}

export function BundleAssemblyPlateParts({
  bundlePlatePartEntries,
  showBundleIdHeader,
}: BundleAssemblyPlatePartsProps) {
  return (
    <>
      {bundlePlatePartEntries.map((bundlePlateParts) => (
        <span key={bundlePlateParts.bundleId}>
          {showBundleIdHeader && (
            <Typography variant="h4" sx={{ ml: 1 }}>
              Bundle {bundlePlateParts.bundleId}
            </Typography>
          )}
          <PropertyTable columns={['Size', 'Type', 'Quantity']}>
            {bundlePlateParts.bundleAssemblyPlateParts.map((platePart) => (
              <TableRow key={getPlateTypeAndSizeString(platePart)} sx={zebraStripingSx}>
                <TableCell>
                  <Typography variant="h6">{getPlateSizeString(platePart)}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="h6">
                    {getPlateTypeString(platePart.plateType, platePart.tangiblePlateTypesForComboPlateType)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="h6">{platePart.overallQuantity}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </PropertyTable>
        </span>
      ))}
    </>
  );
}
